import { render } from "./checkbox.vue?vue&type=template&id=991a09e0&lang=pug"
import script from "./checkbox.vue?vue&type=script&lang=js"
export * from "./checkbox.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/fields/checkbox.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "991a09e0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('991a09e0', __exports__)) {
    api.reload('991a09e0', __exports__)
  }
  
  module.hot.accept("./checkbox.vue?vue&type=template&id=991a09e0&lang=pug", () => {
    api.rerender('991a09e0', render)
  })

}


export default __exports__